import styled from 'styled-components';

import {colors} from 'theme';

export const DescriptionContainer = styled.div`
    display: flex;
    font-size: 16px;
    flex-direction: column;
    gap: 4px;
    margin: 20px 0 24px;

    & h3 {
        font-size: 20px;
        font-weight: 600;
        margin: 0;
    }

    & h4 {
        color: ${colors.brandPrimary};
        font-weight: 500;
        margin: 0;
        position: relative;
    }

    & > span {
        color: ${colors.textSecondary};
    }
`;

export const RowContainer = styled.div`
    display: flex;
    gap: 10px;
    align-items: flex-end;
    width: fit-content;
`;
